export default __webpack_public_path__ + "static/media/step1-bra-support.ddace468.png";